import { render, staticRenderFns } from "./servicoAgendadoChartSideBar.vue?vue&type=template&id=52957000"
import script from "./servicoAgendadoChartSideBar.vue?vue&type=script&lang=js"
export * from "./servicoAgendadoChartSideBar.vue?vue&type=script&lang=js"
import style0 from "./servicoAgendadoChartSideBar.vue?vue&type=style&index=0&id=52957000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports